<template>
  <div class="list-withdraw">
    <div class="d-flex justify-content-end mb-3">
      <div class="wrap-filter">
        <router-link to="/add-withdraw" v-if="role == 2 || role == 5">
          <b-button class="btn mr-2" size="sm">Add Withdraw</b-button>
        </router-link>
        <b-button
          class="btn btn-info btn-sm mr-1"
          @click="isShowFilter = !isShowFilter"
          >Filter</b-button
        >
      </div>
    </div>
    <filter-withdrawal
      v-if="isShowFilter"
      :typeTable="typeWithdraw"
      @setDataFilter="setFilterTable"
    ></filter-withdrawal>

    <table>
      <thead>
        <tr id="top">
          <th scope="col" style="width: 70px">No</th>
          <th scope="col">Owner</th>
          <th scope="col">HIN</th>
          <th scope="col">Withdrawal Date</th>
          <th scope="col">Gold Bar (gr)</th>
          <th scope="col">Quantity</th>
          <th scope="col">Total Gram (gr)</th>
          <th scope="col">Status</th>
          <!-- <th scope="col">Action</th> -->
        </tr>
      </thead>
      <tbody v-if="isLoadingData">
        <tr>
          <td colspan="7">
            <b-spinner></b-spinner>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="(dummy, i) in dataDummy" :key="i">
          <td data-label="No">{{ i + 1 }}</td>
          <td data-label="Owner">{{ dummy.owner }}</td>
          <td data-label="HIN">{{ dummy.hin }}</td>
          <td data-label="Withdrawal Date">{{ dummy.withdrawalDate }}</td>
          <td data-label="Gold Bar (gr)">{{ dummy.goldBar }}</td>
          <td data-label="Quantity">{{ dummy.quantity }}</td>
          <td data-label="Total Gram (gr)">{{ dummy.totalGram }}</td>
          <td data-label="Status">{{ dummy.status }}</td>
        </tr>
        <!-- <tr v-show="withdrawalData.length == 0">
          <td colspan="7">No Data Available in Table</td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import FilterWithdrawal from "../utility/filter/FilterWithdrawal.vue";
import dataWD from '@/assets/data/dataWD.json'
// import FilterListDeposit from "../utility/filter/FilterListDeposit.vue";
export default {
  components: { FilterWithdrawal },
  props: {
    withdrawalData: Array,
    typeWithdraw: {
      type: String,
      default: "onexchange",
    },
    pageNumber: Number,
    totalPerPage: Number,
    totalWithdraw: Number,
    isLoadingData: Boolean,
  },
  data() {
    return {
      isShowFilter: false,
      role: sessionStorage.getItem("role"),
      dataDummy: dataWD
    };
  },
  methods: {
    setFilterTable(event) {
      this.$emit("filterTable", event);
    },
  },
};
</script>

<style></style>
